import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import ImgResponsive from './ImgResponsive';

const ads1 = "/images/SQ_user/SQ_user-1.jpg";
const ads2 = "/images/SQ_user/SQ_user-2.jpg";
const ads3 = "/images/SQ_user/SQ_user-3.jpg";
const ads4 = "/images/SQ_user/SQ_user-4.jpg";
const ads5 = "/images/SQ_user/SQ_user-5.jpg";


const CarouselUser: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <Box sx={{ width: '98%', margin: '0 auto', padding: '10px 2px 2px 2px' }}>
      <Slider {...settings}>
        <div>
          <ImgResponsive src={ads1} alt="We love our customers" />
        </div>
        <div>
          <ImgResponsive src={ads2} alt="Extra Safety Measures for Women Travelers" />
        </div>
        <div>
          <ImgResponsive src={ads3} alt="Easy to use User App" />
        </div>
        <div>
          <ImgResponsive src={ads4} alt="Pune to Mumbai cab fare" />
        </div>
        <div>
          <ImgResponsive src={ads5} alt="Day Fare" />
        </div>
      </Slider>
    </Box>
  );
};

export default CarouselUser;
